import React from 'react';
import { motion } from 'framer-motion';
export function Features() {
  return <section id="features" className="py-24 border-b border-stone-300" data-id="element-919">
      <div className="max-w-6xl mx-auto px-6" data-id="element-920">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-921">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-922">
            {/* Left: Header */}
            <div className="lg:col-span-4" data-id="element-923">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-924">
                Platform
              </p>

              <h2 className="font-serif text-4xl tracking-tight leading-[1.1] text-stone-900 mb-6" data-id="element-925">
                Everything you need to quote, hold, and close
              </h2>

              <p className="text-lg text-stone-600 leading-relaxed" data-id="element-926">
                A complete operating system for group travel distribution. Built
                for revenue teams who need control.
              </p>
            </div>

            {/* Right: Feature list */}
            <div className="lg:col-span-8" data-id="element-927">
              <div className="border-t border-stone-300" data-id="element-928">
                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-929">
                  <div className="col-span-1" data-id="element-930">
                    <span className="font-mono text-xs text-stone-400" data-id="element-931">01</span>
                  </div>
                  <div className="col-span-4" data-id="element-932">
                    <p className="font-medium text-stone-900" data-id="element-933">
                      Multi-Property Quotes
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-934">
                    <p className="text-stone-600" data-id="element-935">
                      Instant quotes across your entire portfolio. Room blocks,
                      dates, occupancy, event needs—handled in seconds.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-936">
                  <div className="col-span-1" data-id="element-937">
                    <span className="font-mono text-xs text-stone-400" data-id="element-938">02</span>
                  </div>
                  <div className="col-span-4" data-id="element-939">
                    <p className="font-medium text-stone-900" data-id="element-940">Smart Holds</p>
                  </div>
                  <div className="col-span-7" data-id="element-941">
                    <p className="text-stone-600" data-id="element-942">
                      Automated hold timers with expiry management. Inventory
                      secured, no manual follow-ups required.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-943">
                  <div className="col-span-1" data-id="element-944">
                    <span className="font-mono text-xs text-stone-400" data-id="element-945">03</span>
                  </div>
                  <div className="col-span-4" data-id="element-946">
                    <p className="font-medium text-stone-900" data-id="element-947">
                      Package Builder
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-948">
                    <p className="text-stone-600" data-id="element-949">
                      Good / Better / Best options auto-generated within your
                      pricing policy. Maximize conversion, protect margins.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-950">
                  <div className="col-span-1" data-id="element-951">
                    <span className="font-mono text-xs text-stone-400" data-id="element-952">04</span>
                  </div>
                  <div className="col-span-4" data-id="element-953">
                    <p className="font-medium text-stone-900" data-id="element-954">
                      Proposal Generation
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-955">
                    <p className="text-stone-600" data-id="element-956">
                      Standardized, branded proposals exported in one click.
                      Ready for client presentation.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-957">
                  <div className="col-span-1" data-id="element-958">
                    <span className="font-mono text-xs text-stone-400" data-id="element-959">05</span>
                  </div>
                  <div className="col-span-4" data-id="element-960">
                    <p className="font-medium text-stone-900" data-id="element-961">Policy Engine</p>
                  </div>
                  <div className="col-span-7" data-id="element-962">
                    <p className="text-stone-600" data-id="element-963">
                      Rate floors, blackout dates, concession limits—enforced
                      automatically across all quotes.
                    </p>
                  </div>
                </div>

                <div className="py-6 grid grid-cols-12 gap-4" data-id="element-964">
                  <div className="col-span-1" data-id="element-965">
                    <span className="font-mono text-xs text-stone-400" data-id="element-966">06</span>
                  </div>
                  <div className="col-span-4" data-id="element-967">
                    <p className="font-medium text-stone-900" data-id="element-968">Audit Trail</p>
                  </div>
                  <div className="col-span-7" data-id="element-969">
                    <p className="text-stone-600" data-id="element-970">
                      Every quote, change, and approval tracked and reportable.
                      Complete visibility for revenue teams.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}